var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 514713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 514712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 29928",
    d: "M1.67188 6.45827C1.67188 3.79756 3.82881 1.64062 6.48952 1.64062H21.906C24.5667 1.64062 26.7236 3.79756 26.7236 6.45827V14.1665C26.7236 16.8272 24.5667 18.9842 21.906 18.9842H6.48952C3.82881 18.9842 1.67188 16.8272 1.67188 14.1665V6.45827Z",
    strokeWidth: 1.44529,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 514711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    id: "Vector",
    d: "M9.61453 6.45312C7.35493 6.45312 5.51953 8.28852 5.51953 10.5481C5.51953 12.8077 7.35493 14.6431 9.61453 14.6431C11.8741 14.6431 13.7095 12.8077 13.7095 10.5481C13.7095 8.28852 11.8741 6.45312 9.61453 6.45312ZM7.80433 13.4965C8.21593 12.9043 8.89213 12.5431 9.61453 12.5431C10.3369 12.5431 11.0131 12.9001 11.4289 13.4965C10.8997 13.8241 10.2823 14.0131 9.61453 14.0131C8.94673 14.0131 8.33353 13.8241 7.80433 13.4965ZM11.9287 13.1185C11.3953 12.3625 10.5385 11.9131 9.61453 11.9131C8.69053 11.9131 7.82953 12.3709 7.30033 13.1185C6.59473 12.4843 6.14953 11.5687 6.14953 10.5481C6.14953 8.63712 7.70353 7.08312 9.61453 7.08312C11.5255 7.08312 13.0795 8.63712 13.0795 10.5481C13.0795 11.5687 12.6343 12.4843 11.9287 13.1185Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    id: "Vector_2",
    d: "M9.61406 8.13281C8.74466 8.13281 8.03906 8.83841 8.03906 9.70781C8.03906 10.5772 8.74466 11.2828 9.61406 11.2828C10.4835 11.2828 11.1891 10.5772 11.1891 9.70781C11.1891 8.83841 10.4835 8.13281 9.61406 8.13281ZM9.61406 10.6528C9.09326 10.6528 8.66906 10.2286 8.66906 9.70781C8.66906 9.18701 9.09326 8.76281 9.61406 8.76281C10.1349 8.76281 10.5591 9.18701 10.5591 9.70781C10.5591 10.2286 10.1349 10.6528 9.61406 10.6528Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line 88",
    d: "M15.1562 7.90234H23.828",
    strokeWidth: 0.963529,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 89",
    d: "M15.1562 10.3086H23.828",
    strokeWidth: 0.963529,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 90",
    d: "M15.1562 13.2031H19.9739",
    strokeWidth: 0.963529,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.f1c40eafebfddfc693320555c1934cc9.svg";
export { ForwardRef as ReactComponent };